var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3085_174420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0735 3.71194L10.6915 3.09402C11.7153 2.07022 13.3752 2.07022 14.399 3.09402C15.4228 4.11783 15.4228 5.77774 14.399 6.80154L13.7811 7.41946M10.0735 3.71194C10.0735 3.71194 10.1508 5.02502 11.3094 6.18362C12.468 7.34222 13.7811 7.41946 13.7811 7.41946M10.0735 3.71194L4.39271 9.39277C4.00794 9.77755 3.81555 9.96993 3.65009 10.1821C3.45492 10.4323 3.28759 10.703 3.15106 10.9895C3.03532 11.2324 2.94928 11.4905 2.7772 12.0067L2.04803 14.1942M13.7811 7.41946L8.10023 13.1003C7.71546 13.4851 7.52307 13.6775 7.31094 13.8429C7.06071 14.0381 6.78996 14.2054 6.50348 14.3419C6.26063 14.4577 6.00251 14.5437 5.48628 14.7158L3.29878 15.445M3.29878 15.445L2.76406 15.6232C2.51002 15.7079 2.22993 15.6418 2.04058 15.4524C1.85123 15.2631 1.78511 14.983 1.8698 14.7289L2.04803 14.1942M3.29878 15.445L2.04803 14.1942",
    stroke: "#EBF0F3",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3085_174420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.992188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.6b0a8bd69baddb9fbb048fe115038adb.svg";
export { ForwardRef as ReactComponent };